package com.patronat.top.client.domain.location

import com.patronat.top.client.data.location.ClientLocationSearchRepository
import com.patronat.top.client.location.ClientGeoLocation
import com.patronat.top.client.location.ClientLocationSuggestion
import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.domain.usecase.BaseUseCase

class ReverseClientLocationUseCase(
    private val repository: ClientLocationSearchRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<ClientGeoLocation, DomainResult<ClientLocationSuggestion?>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: ClientGeoLocation): DomainResult<ClientLocationSuggestion?> {
        return repository.reverseGeocode(command)
    }
}
